import React, { useEffect, useState } from 'react';
import "./AppHeader.scss"
import logo from '../../../images/logo.svg'
import DateTime from '../DateTime/DateTime';
import User from '../User/User';
import Menu from '../Menu/Menu';

const AppHeader = () => {
	return (
		<div className="header">
			<div className="app-container">
				<div className="header__inner">
					<div className="header__left">
						<div className="header__logo">
							<img src={logo} alt="" />
						</div>
						<div className="header__nav">
							<Menu/>
						</div>
					</div>
					<div className="header__right">
						<div className="header__datetime">
							<DateTime/>
						</div>
						<div className="header__user">
							<User/>
						</div>
					</div>
				</div>
			</div>
		</div>

	);
};

export default AppHeader;
